import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ReportsLayer from "../components/ReportsLayer";

const CustomReportsPage = () => {
  return (
    <>
      <MasterLayout pageTitle='Custom Reports'>
        <ReportsLayer mode="custom" />
      </MasterLayout>
    </>
  );
};

export default CustomReportsPage;
